export function transformAutoInvoicingUIToModel(
  autoInvoicingEnabled: boolean | undefined
): boolean {
  return autoInvoicingEnabled ?? true;
}
